import SimpleBarReact from "simplebar-react";
// @mui
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

// const RootStyle = styled("div")(() => ({
//   flexGrow: 1,
//   height: "100%",
//   overflow: "hidden",
// }));

const SimpleBarStyle = styled(SimpleBarReact)(() => ({
  "& .simplebar-scrollbar": {
    "&:before": {
      backgroundColor: "#BDBDBD",
      left: 0,
      right: 0,
    },
    "&.simplebar-visible:before": {
      opacity: 1,
    },
  },
  "& .simplebar-track.simplebar-vertical": {
    width: 8,
    // background: "#EEEEEE",
    borderRadius: "8px",
    ".simplebar-scrollbar:before": {
      top: 0,
      bottom: 0,
    }
  },
}));

// ----------------------------------------------------------------------

export default function Scrollbar({ children, sx, ...other }) {
  const userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (isMobile) {
    return (
      <Box sx={{ overflowX: "auto", ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    // <RootStyle>
      <SimpleBarStyle autoHide={false} clickOnTrack={false} sx={sx} {...other}>
        {children}
      </SimpleBarStyle>
    // </RootStyle>
  );
}
